import React, { useState } from "react";
import useDebounce from "hooks/useDebounce";
import Modal from "react-bootstrap/Modal";
import AssignShippingAgent from "../../shipments/components/AssignShippingAgent";
import { EditUnderlineIcon, ProfileFilledIcon } from "asset/icons";
import capitalizeWords from "utilities/capitalizeWords";
import { useQuery } from "react-query";
import useUserDetails from "hooks/useUserDetails";
import { handleGetWalletBeneficiaries, handleVerifyAccount } from "api/fetchers";
import { SearchInput as InputField } from "component/TableSearchInput";
import { GenericBtn } from "pages/finance/v2/FinanceRequest";
import { Button } from "component/ui/Button";
import Select from "react-select";
import Input from "component/form/Input";
import { Danger } from "iconsax-reactjs";
import Dropdown from "component/form/dropDown";
import { cn, isValidEVMAddress } from "lib/utils";

const AddPaymentDetailsModal = ({
    show,
    closeModal,
    category = "Invoice",
    bankContractEmployer,
    setBankContractEmployer,
    selectedBank,
    setSelectedBank,
    accountName,
    setAccountName,
    accountNumber,
    setAccountNumber,
    onSubmit,
    isPoOrInvoice,
  network,
  setNetwork,
  uniqueWallet,
  setUniqueWallet,
  walletTouched,
  setWalletTouched,
  saveRecipient, setSaveRecipient
}) => {
    const [open, setOpen] = useState(false);
  const { bankListOptions, currency, businessId } = useUserDetails({
    enableBankList: true,
  });

  const isCrypto = currency === 'USDT' || currency === 'USDC';

  const [activeTab, setActiveTab] = useState("new");
  const [selectedRecipient, setSelectedRecipient] = useState("1");
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

  const { data, isLoading } = useQuery({
    queryKey: ['wallet-beneficiaries', debouncedSearchQuery, currency, businessId],
    queryFn: () => handleGetWalletBeneficiaries({
      businessId,
      currency,
      search: debouncedSearchQuery,
    }),
    enabled: !!businessId && !!currency,
  })

  const debouncedSearch = useDebounce((val) => {
    setDebouncedSearchQuery(val);
  }, 500);

  const savedRecipientsList = data
    ?.filter(r => r.name.toLowerCase().includes(debouncedSearchQuery.toLowerCase()))
    ?? [];


  const isWalletInvalid = Boolean(uniqueWallet && walletTouched && !isValidEVMAddress(uniqueWallet));

    const { isLoading: verifyingAccount } = useQuery({
        queryKey: ["accountNumber", accountNumber, selectedBank?.value],
        enabled:
            typeof accountNumber === "string" &&
            accountNumber.length >= 10 &&
            !!selectedBank?.value,
        queryFn: () => handleVerifyAccount(accountNumber, selectedBank?.value),
        onSettled: (data) => {
            if (!data?.data?.error) {
                setAccountName(data?.data?.accountName);
            }
        },
    });

  const isDisabled = isCrypto ? (!uniqueWallet || !walletTouched || !network) : (!accountName || !accountNumber || !selectedBank);
  console.log({ accountName, accountNumber, selectedBank, savedRecipientsList })
    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="border-0 "
            onHide={closeModal}
        >
            <Modal.Body
                style={{
                    borderRadius: "16px",
                    padding: "0px",
                    border: "none",
                }}
                className="bg-white rounded-md"
            >
                <div className="w-full gap-4 px-4 py-4 ">
                    <div className="flex items-center justify-between">
                        <h5 className="text-xl font-semibold text-gray-90">
                Add payment information
                        </h5>

                        <span
                            className="cursor-pointer material-icons"
                            style={{ color: "#667085" }}
                            onClick={closeModal}
                        >
                            close
                        </span>
                    </div>

                    <p className="text-base font-normal text-gray-50">
                        Include payment information for this {category}
                    </p>
          </div>

          {!isCrypto && (
            <div className="flex bg-[#F9FAFB] rounded-lg p-1 mx-4 mt-2">
              <button
                className={`flex-1 py-2.5 text-sm font-medium rounded-md transition-all ${activeTab === "new"
                  ? "bg-white shadow-[0_1px_3px_rgba(0,0,0,0.1)] text-gray-900"
                  : "text-gray-500 hover:text-gray-700"
                  }`}
                onClick={() => {
                  setActiveTab("new")
                  setAccountNumber("")
                  setAccountName("")
                  setSelectedBank('')
                  setSelectedRecipient("")
                }}
              >
                New recipient
              </button>
              <button
                className={`flex-1 py-2.5 text-sm font-medium rounded-md transition-all ${activeTab === "saved"
                  ? "bg-white shadow-[0_1px_3px_rgba(0,0,0,0.1)] text-gray-900"
                  : "text-gray-500 hover:text-gray-700"
                  }`}
                onClick={() => setActiveTab("saved")}
              >
                Saved recipient
              </button>
            </div>
          )}


          {!isCrypto ? (
            activeTab === "new" ? (
              <div className="flex flex-col w-full gap-3 px-4 py-4 ">
                    {isPoOrInvoice || !isPoOrInvoice ? null : (
                        <>
                            {bankContractEmployer ? (
                                <div>
                                    <label className="mb-1 text-sm text-gray-70">
                                        Contract Employer
                                    </label>
                                    <div
                                        onClick={() => {
                                            setBankContractEmployer(null);
                                        }}
                                        className="bg-white !border !border-secondary-50 rounded-lg !p-4 flex items-center relative cursor-pointer"
                                    >
                                        <input
                                            required
                                            defaultValue={bankContractEmployer?._id}
                                            className="absolute top-0 left-0 h-full -z-30"
                                        />

                                        <ProfileFilledIcon className="rounded-full mr-1.5 -ml-1 -my-0.5" />
                                        <span className="font-[450] mr-auto text-main-dark">
                                            {capitalizeWords(
                                                bankContractEmployer?.name?.toLowerCase()
                                            )}
                                        </span>

                                        <EditUnderlineIcon className="size-[22px]" />
                                    </div>
                                </div>
                            ) : (
                                <AssignShippingAgent
                                    forFinance={true}
                                    show={open}
                                    setShow={setOpen}
                                    selectedUser={bankContractEmployer}
                                    setSelectedUser={(value) => {
                                        setBankContractEmployer(value);
                                    }}
                                />
                            )}
                        </>
                    )}

                    <Select
                        options={bankListOptions}
                        className="react-select-container bg-[#EFF0FA]"
                        classNamePrefix="react-select"
                        placeholder={verifyingAccount ? "Loading..." : "Select a bank"}
                        onChange={(value) => setSelectedBank(value)}
                        value={selectedBank}
                        isClearable={true}
                    />

                    <Input
                        inputClassName="!bg-[#EFF0FA] shadow-none mt-1"
                        type="text"
                        name="accountNumber"
                        onChange={(value) => {
                            setAccountNumber(value);
                        }}
                        value={accountNumber}
                        placeholder="Account number"
                    />
                    <div>
                        <InputField
                            onChange={(value) => {
                                setAccountName(value);
                            }}
                            value={verifyingAccount ? "Loading..." : accountName}
                            showIcon={false}
                            disabled={true}
                            placeholder="Account name"
                            wrapperClassName="max-w-full h-[56px]"
                        />
                    </div>

                <div className="flex items-center gap-2 mt-2">
                  <input
                    type="checkbox"
                    id="saveRecipient"
                    checked={saveRecipient}
                    onChange={(e) => setSaveRecipient(e.target.checked)}
                    className="w-4 h-4 rounded cursor-pointer"
                    style={{ accentColor: '#6F00FF' }}
                  />
                  <label htmlFor="saveRecipient" className="text-sm text-gray-900 font-medium cursor-pointer">
                    Save this recipient
                  </label>
                </div>
              </div>
            ) : (
              <div className="flex flex-col w-full gap-4 px-4 py-4">
                <Input
                  placeholder="Search by name"
                  value={searchQuery}
                  type="text"
                  onChange={(val) => {
                    setSearchQuery(val);
                    debouncedSearch(val);
                  }}
                  wrapperClassName="max-w-full h-[56px]"
                />

                <div className="flex flex-col gap-3 max-h-[300px] overflow-y-auto">
                  {isLoading ? (
                    <div className="text-center text-sm text-gray-500 py-6">
                      Loading recipients...
                    </div>
                  ) : savedRecipientsList.length === 0 ? (
                    <div className="text-center text-sm text-gray-500 py-6">
                      No saved recipients found.
                    </div>
                  ) : (
                    savedRecipientsList.map((recipient) => {
                      const isSelected = selectedRecipient === recipient?._id;
                      return (
                        <div
                          key={recipient?._id}
                          onClick={() => {
                            setSelectedRecipient(recipient?._id)
                            setSelectedBank({ label: recipient?.bankName, value: recipient?.bankCode })
                            setAccountNumber(recipient?.accountNumber)
                            setAccountName(recipient?.name)
                          }}
                          style={{ border: isSelected ? '1px solid #6F00FF' : '1px solid' }}
                          className={`border rounded-lg p-3 flex items-center gap-3 cursor-pointer transition-all`}
                        >
                          <div className="bg-[#F3F4F6] text-[#4B5563] text-[10px] font-semibold rounded-full min-w-10 min-h-10 flex items-center justify-center">
                            {recipient?.name?.substring(0, 2)?.toUpperCase() || "ME"}
                          </div>
                          <div className="flex flex-col">
                            <span className={`text-sm font-semibold ${isSelected ? 'text-[#6F00FF]' : 'text-gray-900'}`}>
                              {recipient?.name}
                            </span>
                            <span className="text-sm text-gray-500 font-normal mt-0.5">
                              {recipient?.accountNumber}
                            </span>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            )
          )
            :
            (<div className="p-4 space-y-4">
              <div>
                <label className={cn(`text-sm text-gray-70 font-normal mb-1 block`)}>
                  Wallet address
                </label>
                <Input
                  inputClassName="!bg-[#EFF0FA] shadow-none"
                  className="!mt-0"
                  type="text"
                  name="uniqueWallet"
                  onChange={(value) => {
                    setUniqueWallet(value);
                    if (!walletTouched) setWalletTouched(true);
                  }}
                  value={uniqueWallet}
                  placeholder="Enter unique wallet address"
                />
                {isWalletInvalid && (
                  <p className="text-xs text-[#C01515] font-normal mt-1">
                    Please enter a valid Polygon/Base address (0x followed by 40 hexadecimal
                    characters).
                  </p>
                )}
              </div>

              <div>
                <Dropdown
                  value={network}
                  options={["POLYGON", "BASE"].map((option) => ({
                    label: option,
                    value: option?.toLowerCase(),
                  }))}
                  onChange={(value) => setNetwork(value)}
                  label="Network"
                  labelClassName="mb-1 text-sm text-gray-70 font-normal"
                  inputBg="#EFF0FA"
                  placeholder="Select a network"
                />
              </div>

              <div className="bg-[#FFFCF5] rounded-lg p-3 flex items-start gap-2.5">
                <div className=" text-[#D97706] size-8 grid place-items-center bg-[#FFEFC6] rounded-full p-1.5">
                  <Danger variant="Bold" size="18" color="#D97706" />
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-[#494E6E] leading-tight">
                    Double-check the wallet address and network before submitting
                  </span>
                  <span className="text-sm text-[#494E6E] mt-0.5 leading-normal">
                    Incorrect details may result in permanent loss of funds
                  </span>
                </div>
              </div>
            </div>)}
                <div
                    className="flex items-center justify-end px-4 py-3 gap-x-5"
                    style={{
                        borderTop: "1px solid #E7E9FB",
                    }}
                >
                    <Button onClick={closeModal} className="" variant="ghost">
                        Cancel
                    </Button>
                    <GenericBtn disabled={isDisabled} onClick={onSubmit} text="Continue" />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddPaymentDetailsModal;
